import { useAccountTypeBrowse } from "@features/tickets/shared/hooks/useAccountTypeBrowse";
import { BANK_ACCOUNT_TYPE } from "./banks.constants";

export function useBanksBrowse() {
  return useAccountTypeBrowse({
    accountType: BANK_ACCOUNT_TYPE,
  });
}
